import React, { useEffect } from "react";
import LeftSideBar from "./components/LeftSideBar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AOS from "aos";
import { Container, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Routes from "./utils/routes";
import "aos/dist/aos.css";
import "./App.css";
require("dotenv").config();

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    //initialize aos animations
    AOS.init({ duration: 1000 });

    //get language settings
    let lang = localStorage.getItem("language");
    i18n.changeLanguage(lang);
  }, [i18n]);

  const Main = () => {
    return (
      <Container>
        <Row>
          <Col lg={3} className="leftside">
            <LeftSideBar />
          </Col>
          <Routes />
        </Row>
      </Container>
    );
  };

  return (
    <Router>
      <div className="App" dir={t("language") === "en" ? "rtl" : "ltr"}>
        <Switch>
          <Route path="/" component={Main} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
